// ========================================================================
// auth.service.ts 내용 시작
// ========================================================================

// 필요한 Firebase Auth 관련 import 추가 (예시)
import type { User } from 'firebase/auth'; // 가정: 실제 구현 시 필요
import type { AuthUser, LoginInput, LoginOutput, IAuthService } from '@wowpress/state-machine'; // 패키지에서 타입/인터페이스 import


/**
 * Firebase Authentication을 사용하는 인증 서비스 구현체 (예시)
 * !!주의: 실제 구현 시 Firebase 초기화 및 관련 로직 필요!!
 */
export class FirebaseAuthService implements IAuthService {
  // private auth = getAuth(); // 실제 Firebase Auth 인스턴스 가져오기

  async login(input: LoginInput): Promise<LoginOutput> {
    console.log('[FirebaseAuthService] Login attempt:', input.email);
    // 실제 Firebase 로그인 로직 구현
    // 예시: 이메일/비밀번호 로그인
    if (input.email && input.password) {
      // const userCredential = await signInWithEmailAndPassword(this.auth, input.email, input.password);
      // const firebaseUser = userCredential.user;
      // const token = await firebaseUser.getIdToken();
      // 임시 성공 응답
      const mockUser: AuthUser = { uid: 'mockUid123', email: input.email, displayName: 'Mock User' };
      return { user: mockUser, token: 'mockToken', message: '로그인 성공 (Mock)' };
    }
    // 예시: 소셜 로그인 등 다른 방식 처리
    // ...

    // 구현되지 않았거나 실패한 경우
    throw new Error('로그인 방식이 지원되지 않거나 실패했습니다.');
  }

  async logout(): Promise<void> {
    console.log('[FirebaseAuthService] Logout attempt');
    // 실제 Firebase 로그아웃 로직 구현
    // await signOut(this.auth);
    console.log('[FirebaseAuthService] Logout successful (Mock)');
  }

  async getCurrentUser(): Promise<AuthUser | null> {
    console.log('[FirebaseAuthService] Getting current user');
    // 실제 Firebase 현재 사용자 확인 로직 구현
    // const firebaseUser = this.auth.currentUser;
    // 임시 응답 (로그인 상태라고 가정)
    const mockUser: AuthUser = { uid: 'mockUid123', email: 'mock@example.com', displayName: 'Mock User' };
    // return firebaseUser ? { uid: firebaseUser.uid, email: firebaseUser.email, displayName: firebaseUser.displayName } : null;
    return mockUser; // 임시 반환
  }

  // onAuthStateChanged 구현 (필요한 경우)
  // onAuthStateChanged(callback: (user: AuthUser | null) => void): () => void {
  //   console.log('[FirebaseAuthService] Setting up auth state listener');
  //   const unsubscribe = onAuthStateChanged(this.auth, (firebaseUser) => {
  //     const authUser = firebaseUser ? { uid: firebaseUser.uid, email: firebaseUser.email, displayName: firebaseUser.displayName } : null;
  //     callback(authUser);
  //   });
  //   return unsubscribe;
  // }
}


// ========================================================================
// auth.service.ts 내용 끝
// ======================================================================== 